import { render, staticRenderFns } from "./PartnershipsModal.vue?vue&type=template&id=1d5add84&scoped=true"
import script from "./PartnershipsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnershipsModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5add84",
  null
  
)

export default component.exports